import React, { useEffect } from 'react';
import { useLocation } from 'react-router';

type OwnProps = React.PropsWithChildren<unknown>;

const ScrollToTop = ({ children }: OwnProps) => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return <>{children}</>;
};

export default ScrollToTop;
